import React from 'react';
import { createSvgIcon } from '../Svg';

export default createSvgIcon(
  <path d="M25 4C14 4 5 13 5 24C5 35 14 44 25 44C36 44 45 35 45 24C45 13 36 4 25 4ZM25 38V10C32.7059 10 39 16.2941 39 24C39 31.7059 32.7059 38 25 38Z" />,
  'theme'
);
